import fetch from "lib/fetch";
import type { ReportUserInterface } from "types/reportUser";

type ReportUserResponse = { data: ReportUserInterface };

export const createReportUserRequest = (data: HashMap<unknown>) =>
    fetch.post<ReportUserResponse>("report_user", data);
